import { useState, useEffect } from 'preact/hooks';

export default function BundleBuilderHeader({}) {
    const [isHeaderAtTop, setIsHeaderAtTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const headerElement = document.getElementById('bb-header');
            if (!headerElement) return;
            
            // Get the position of the bb-header 
            const headerRect = headerElement.getBoundingClientRect();
            setIsHeaderAtTop(headerRect.top <= 0);
        };
        
        window.addEventListener('scroll', handleScroll);
        
        handleScroll();

        // Clean up
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    
    return (
        <div className={`tw-relative tw-z-[-2] tw-w-full tw-border-b tw-border-solid tw-border-[#eee] tw-bg-white ${!isHeaderAtTop ? 'tw-hidden' : ''}`}>
            <div class={`tw-flex tw-justify-center tw-py-16`}>
                <a href="#bottles" className='tw-transition-transform tw-duration-300 tw-ease-in-out tw-mr-24 tw-text-[#00AAF5]'>1. Bottles</a>
                <a href="#flavors" className='tw-transition-transform tw-duration-300 tw-ease-in-out tw-mr-24 tw-text-[#00AAF5]'>2. Flavors</a>
                <a href="#extras" className='tw-transition-transform tw-duration-300 tw-ease-in-out tw-text-[#00AAF5]'>3. Extras</a>
            </div>
        </div>
    );
}